import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {PaginatedResponse, PaginationParams, Tramite} from '../../models/la';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TramiteService {

  constructor(
    private http: HttpClient
  ) {}

  async getTramites(laId: string){
    const result = await lastValueFrom(this.http.get<Tramite[]>(`${environment.backendUrl}/lesgislative_actions/${laId}/tramites`));
    return result;
  }

  async getTramitesPaginated(laId: string, params: PaginationParams = {}): Promise<PaginatedResponse<Tramite>> {
    const queryParams = new URLSearchParams();
    if (params.limit !== undefined) queryParams.set('limit', params.limit.toString());
    if (params.offset !== undefined) queryParams.set('offset', params.offset.toString());
    const queryString = queryParams.toString();
    const url = `${environment.backendUrl}/v2/lesgislative_actions/${laId}/tramites${queryString ? `?${queryString}` : ''}`;
    return await lastValueFrom(this.http.get<PaginatedResponse<Tramite>>(url));
  }

  async post(id: string, tramite: {date: number, description: string, delta: any}) {
    const response = await lastValueFrom(this.http.post<{ id: string }>(`${environment.backendUrl}/lesgislative_actions/${id}/tramites`, tramite));
    await this.getTramites(id);
    return response;
  }

}
